import {
  Component,
  ChangeDetectionStrategy,
  HostListener,
  inject,
  signal,
} from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { NavigationEnd, Router, RouterOutlet } from '@angular/router';

import { filter, map } from 'rxjs';

import { Header } from './layout/header/header';
import { Footer } from './layout/footer/footer';
import { environment } from '@environments';
import { RadioPlayerComponent } from '@components/radio-player/radio-player.component';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, Header, Footer, RadioPlayerComponent],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styleUrl: './app.scss',
})
export class App {
  private router = inject(Router);

  private readonly navEnd$ = this.router.events.pipe(
    filter((e): e is NavigationEnd => e instanceof NavigationEnd),
    map((e) => e.urlAfterRedirects),
  );
  readonly currentRoute = toSignal(this.navEnd$, {
    initialValue: this.router.url,
  });

  radioEnabled = signal(false);
  @HostListener('window:resize')
  onResize() {
    this.setAppHeight();
  }

  private setAppHeight() {
    const doc = document.documentElement;
    const height = window.innerHeight;

    doc.style.setProperty('--app-height', `${height < 500 ? 500 : height}px`);
  }

  ngOnInit(): void {
    this.setAppHeight();

    this.radioEnabled.set(
      environment.sonicRadioPort !== undefined &&
        environment.sonicRadioPort !== null,
    );
  }
}
